export enum Permission {
  USERS_READ = "users.read",
  USERS_CREATE = "users.create",
  USERS_UPDATE = "users.update",
  USERS_DELETE = "users.delete",

  ADMINS_READ = "admins.read",
  ADMINS_CREATE = "admins.create",
  ADMINS_UPDATE = "admins.update",
  ADMINS_DELETE = "admins.delete",

  ROLES_READ = "roles.read",
  ROLES_CREATE = "roles.create",
  ROLES_UPDATE = "roles.update",
  ROLES_DELETE = "roles.delete",

  SYSTEM_SETTINGS_READ = "system.settings.read",
  SYSTEM_SETTINGS_UPDATE = "system.settings.update",

  AUDIT_LOGS_READ = "audit_logs.read",
  // Notifications
  ADMIN_NOTIFICATIONS_READ = "admin_notifications.read",
  ADMIN_NOTIFICATIONS_UPDATE = "admin_notifications.update",
  USER_NOTIFICATIONS_READ = "user_notifications.read",
  USER_NOTIFICATIONS_UPDATE = "user_notifications.update",
  USER_NOTIFICATIONS_CREATE = "user_notifications.create",

  // Dashboard
  DASHBOARD_READ = "dashboard.read",

  // Cards
  CARDS_READ = "cards.read",
  CARDS_CREATE = "cards.create",
  CARDS_UPDATE = "cards.update",
  CARDS_DELETE = "cards.delete",

  // Sources
  SOURCES_READ = "sources.read",
  SOURCES_CREATE = "sources.create",
  SOURCES_UPDATE = "sources.update",
  SOURCES_DELETE = "sources.delete",

  // Card Interests
  CARD_INTERESTS_READ = "card_interests.read",
  CARD_INTERESTS_CREATE = "card_interests.create",
  CARD_INTERESTS_UPDATE = "card_interests.update",
  CARD_INTERESTS_DELETE = "card_interests.delete",

  // Listings
  LISTINGS_READ = "listings.read",
  LISTINGS_CREATE = "listings.create",
  LISTINGS_UPDATE = "listings.update",
  LISTINGS_DELETE = "listings.delete",

  // Price Points
  PRICE_POINTS_READ = "price_points.read",
  PRICE_POINTS_CREATE = "price_points.create",
  PRICE_POINTS_UPDATE = "price_points.update",
  PRICE_POINTS_DELETE = "price_points.delete",

  // Job Runs
  JOB_RUNS_READ = "job_runs.read",
  JOB_RUNS_CREATE = "job_runs.create",
  JOB_RUNS_UPDATE = "job_runs.update",
  JOB_RUNS_DELETE = "job_runs.delete",
}
